export default "__VITE_ASSET__STPfwdne__"